import apiClient from './client';
import {VideoContextResponseMessage} from '@/types/VideoContextResponse';

/**
 * Fetches the context data for a given music video.
 * Chooses secure or public endpoint based on authentication state.
 * @param musicVideo Video identifier
 * @param secure Whether to use secure (/secure) or public (/public) endpoint
 */
export async function fetchVideoContext(
  musicVideo: string,
  secure: boolean = true
): Promise<VideoContextResponseMessage> {
  const prefix = secure ? '/secure/video/context' : '/public/video/context';
  const response = await apiClient.get<VideoContextResponseMessage>(
      `${prefix}/${encodeURIComponent(musicVideo)}`
  );
  return response.data;
}
